import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteSingleSimulation } from 'Services';
import { RQ_ALL_SIMULATIONS, RQ_SINGLE_SIMULATION } from 'Utils';
import { useTranslation } from 'react-i18next';
import useDeleteSimulationErrorHandler from './useDeleteSimulationErrorHandler';

function useDeleteSingleSimulation(id: number | null) {
    const { t } = useTranslation();
    const queryClient = useQueryClient();
    const errorHandler = useDeleteSimulationErrorHandler({
        preContentMessage: t('Failed to delete simulation'),
        title: t('Unable to delete simulation')
    });
    return useMutation([RQ_SINGLE_SIMULATION, id], () => deleteSingleSimulation(id!), {
        onSuccess: () => {
            queryClient.invalidateQueries([RQ_ALL_SIMULATIONS]);
        },
        onError: errorHandler
    });
}

export default useDeleteSingleSimulation;
